import {applyDefaultProps, InteractionEventTypes, PixiComponent} from '@inlet/react-pixi';
import {Graphics, InteractionEvent} from 'pixi.js';

/**
 * (leftTopRadius, rightTopRadius, rightBottomRadius, leftBottomRadius)
 */
type RectangleBorderRadius = [number, number, number, number];

export type Border = {
    width?: number;
    color?: number;
};

export type RectangleProps = {
    x?: number;
    y?: number;
    width: number | 'auto';
    height: number;
    fill: number;
    alpha?: number;
    round?: number | RectangleBorderRadius;
    border?: Border;
    interactive?: boolean;
    buttonMode?: boolean;
    name?: string;
};

type InteractionEvents = {
    [P in InteractionEventTypes]?: (
        event: InteractionEvent
    ) => void;
};

export const Rectangle = PixiComponent<RectangleProps & InteractionEvents, Graphics>('Rectangle', {
    create: () => {
        const graphics = new Graphics();

        graphics.name = 'Rectangle';

        return graphics;
    },

    applyProps: (instance, oldProps, props) => {
        const { x = 0, y = 0, width, height, fill, alpha = 1, round, border, ...newProps} = props;
        const { x : oldX, y : oldY, width : oldW, height : oldH, fill: oldF, alpha: oldA, round: oldR, border: oldB, ...oldP} = oldProps;
        const widthSize = width === 'auto' ? -1 : width;

        instance.clear();
        instance.beginFill(fill, alpha);

        if (border) {
            const {width = 1, color = 0x000000} = border;

            instance.lineStyle(width, color, 1);
        }

        if (round) {
            if (typeof round === 'number') {
                instance.drawRoundedRect(x, y, widthSize, height, round);
            } else {
                instance.moveTo(x + round[0], y);
                instance.lineTo(x + widthSize - round[1], y);
                instance.quadraticCurveTo(x + widthSize, y, x + widthSize, y + round[1]);
                instance.lineTo(x + widthSize, y + height - round[2]);
                instance.quadraticCurveTo(x + widthSize, y + height, x + widthSize - round[2], y + height);
                instance.lineTo(x + round[3], y + height);
                instance.quadraticCurveTo(x, y + height, x, y + height - round[3]);
                instance.lineTo(x, y + round[0]);
                instance.quadraticCurveTo(x, y, x + round[0], y);
                instance.closePath();
            }
        } else {
            instance.drawRect(x, y, widthSize, height);
        }

        instance.endFill();

        applyDefaultProps(instance, oldP, newProps);
    }
});
